import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/14_card_back_white_puppy/14_card_back_white_puppy"
 * Contains 1 texture(s)
 */
export class CardsBacks14CardBackWhitePuppyAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/14_card_back_white_puppy/14_card_back_white_puppy';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '14_white_puppy.png'
    ] as const;
}
